import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';

export const FullPageEditorLoader = LoadablePaint({
	name: MustPreloadLoadableNames.FullPageEditorLoader,
	loader: async () => {
		const { FullPageEditorComponent } = await import(
			/* webpackChunkName: "loadable-FullPageEditorComponent" */ './FullPageEditorComponent.tsx'
		);
		return FullPageEditorComponent;
	},
});
